import {useState} from 'react';
import {
    Box,
    Button,
    ButtonProps
} from '@mantine/core';
import {EditFormDrawer} from "../drawers/EditFormDrawer.tsx";


export const EditButton = (props: ButtonProps) => {
    const [visible, setVisible] = useState(false);

    if (visible) {
        return (
            <Box
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                }}
            >
                <EditFormDrawer
                    opened={visible}
                    onClose={() => setVisible(false)}
                />
            </Box>
        );
    } else {
        return (
            <Button
                onClick={() => {
                    setVisible(true);
                }}
                {...props}
            />
        );
    }
};
